/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import Promise from 'es6-promise';
import {cloneDeep} from 'lodash';

export const by = (attr, value) => obj => obj[attr] === value;

export const nonEmpty = elt => !!elt;

/**
 * Returns a function for converting an array to map by attribute
 *
 * @param attr attribute, which values is going to be used a map key
 * @param initial map object
 * @param clone whether deep clone of a map is needed (immutable) or not (mutable)
 * @returns {Function}
 */
export function toMapBy(attr, initial = {}, clone = true) {
  return array => {
    if (!array) return initial;
    const result = clone ? cloneDeep(initial) : initial;
    array.forEach(obj => result[obj[attr]] = obj);
    return result;
    // TODO: compare performance
    // return array.reduce((acc, obj) => ({...acc, [obj[attr]]: obj}), initial);
  };
}

/**
 * Sort helper. Use list of pairs of attribute name and order (1 - asc, -1 - desc)
 * @param attr first attribute
 * @param order first attribute order
 * @param pairs rest pairs
 * @returns {function(*=, *=): number}
 */
export const sortByAttrs = ([attr, order, ...pairs]) => {
  switch (typeof attr) {
    case 'function':
      return (a, b) => attr(a) === attr(b) ? (pairs.length === 0 ? 0 : sortByAttrs(pairs)(a, b)) : (attr(a) > attr(b) ? order : -order);
    case 'string':
      return (a, b) => a[attr] === b[attr] ? (pairs.length === 0 ? 0 : sortByAttrs(pairs)(a, b)) : (a[attr] > b[attr] ? order : -order);
    default:
      console.warn(`sorting by ${attr} with order ${order}`);
      return (a, b) => a[attr] === b[attr] ? 0 : (a[attr] > b[attr] ? order : -order);
  }
};

/**
 * Convert list of values to tree based on path attribute
 * @param list values
 * @param attr attribute name
 * @param sep path separator
 * @returns {*}
 */
export function convertToTree(list, attr, sep = '|') {
  if (!list || list.length === 0) {
    return [];
  }

  function set(obj = {}, path, value) {
    const [first, ...rest] = path;
    if (!rest || rest.length === 0) {
      obj[first] = value;
    } else {
      obj[first] = set(obj[first], rest, value);
    }
    return obj;
  }

  function toNode([id, value]) {
    if (value.name) {
      return {id: value.name, label: value.name.split(sep).slice(-1)[0], ...value};
    }
    const children = Object.entries(value).map(toNode);
    return {id, name: id, children};
  }

  const tree = {};
  list.forEach(node => {
    set(tree, node[attr].split(sep), node);
  });
  return Object.entries(tree).map(toNode);
}

export function hashCode(str) {
  return str.split('').reduce((prevHash, currVal) =>
  (((prevHash << 5) - prevHash) + currVal.charCodeAt(0)) | 0, 0);
}

export function isNumber(n) {
  return !isNaN(parseFloat(n)) && !isNaN(n - 0);
}

/**
 * Delay for n seconds withing scope of async function
 *
 * @param sec seconds to wait
 * @returns {Promise<void>}
 */
export async function delay(sec) {
  return new Promise(resolve => setTimeout(resolve, sec * 1000, null));
}

export function round(n, d) {
  const c = Math.pow(10, d);
  return Math.round(n * c) / c;
}
